import { useTranslation } from "react-i18next";

import { Stack } from "@mui/system";

import CustomChip from "../../../../components/common/CustomChip";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import { FAILED_TESTS_CHIP_PREFIX } from "../../../../utils/failedTests";
import Disclaimer from "../../../../components/common/Disclaimer";

import WarningIcon from "../../../../assets/WarningIcon.svg";

export default function Banners(props: any) {
  const {
    expandAvailableProgramsView,
    expandLeverageAndTests,
    showLoanDetails,
    applicationName,
    evaluationID,
    chipsData,
    noAssignedPartner,
    disclaimer,
    showBanners,
    showBridgePricingBanner
  } = props;

  const { t } = useTranslation();

  return (
    <div>
      <div style={{ padding: "16px" }}>
        {showBridgePricingBanner ? (
          <Disclaimer
            boldText={t("")}
            children={<span>{t("bridgeTcPricingBanner")}</span>}
            customClass="disclaimerBox"
            showClose={false}
          />
        ) : null}
        {noAssignedPartner && !expandAvailableProgramsView && showBanners ? (
          <Disclaimer
            boldText={t("")}
            children={
              <span className="warning-div">
                <img src={WarningIcon} alt="warning,svg" />
                &ensp;
                {t(noAssignedPartner)}
              </span>
            }
            customClass="warningMessage"
            showClose={false}
          />
        ) : null}
        {!(expandLeverageAndTests && expandAvailableProgramsView) &&
          showBanners && (
            <Disclaimer
              boldText={t("disclaimer")}
              children={disclaimer}
              customClass="disclaimerBox"
              showClose={true}
            />
          )}
        {!(expandLeverageAndTests && expandAvailableProgramsView) && (
          <>
            {showLoanDetails ? (
              <div className="div-space-between">
                <div>
                  <span>
                    <b>{t("applicationName")}: </b>
                    {applicationName}
                  </span>
                </div>
                <div>
                  <span>
                    <b>
                      {t("evaluationID")}: {evaluationID}
                    </b>
                  </span>
                </div>
              </div>
            ) : null}
          </>
        )}
        <div>
          <Stack
            direction="row"
            className="mt-12"
            style={{ flexWrap: "wrap" }}
          >
            {chipsData?.map((chip: string, idx: number) => {
              return (
                <CustomChip
                  key={idx}
                  size="small"
                  label={
                    chip?.startsWith(FAILED_TESTS_CHIP_PREFIX) ? (
                      <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <ReportProblemOutlinedIcon style={{ fontSize: 16, color: "#B30C00" }} />
                        {chip}
                      </span>
                    ) : (
                      chip
                    )
                  }
                  data-testid={chip?.startsWith(FAILED_TESTS_CHIP_PREFIX) ? "failed-tests-chip" : undefined}
                  variant="outlined"
                  className={
                    chip?.startsWith(FAILED_TESTS_CHIP_PREFIX)
                      ? "failed-tests-chip"
                      : chip?.includes("Price Exception: Requested")
                      ? "requested-chip"
                      : chip?.includes("Price Exception: Rejected")
                        ? "rejected-chip"
                        // Same colors as the old escalation "pending-chip" —
                        // makes this stand out from the plain chipData ones.
                        : chip === t("pricedManuallyChip")
                          ? "priced-manually-chip"
                          : "chipData"
                  }
                />
              );
            })}
          </Stack>
        </div>
      </div>
      <div
        data-testid="divider"
        style={{ borderBottom: "1px solid #D3D3D3", marginTop: "4px" }}
      ></div>
    </div>
  );
}
